(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curvyglow-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-offer-gifts')) {
    customElements.define('cg-offer-gifts', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.controller = new AbortController();
        this.update = () => {
          const selectedTier = this.form.querySelector('.sss-bundle-block__radio:checked');
          const quantityField = this.form.querySelector('[name="quantity"]:checked, input[name="quantity"]:not([type="radio"])');
          const quantity = selectedTier ? Number(selectedTier.value) + 1 : Number(quantityField?.value || 1);
          const purchase = this.form.querySelector('[name="selling_plan_group"]:checked');
          const plan = this.form.querySelector('[name="selling_plan"]:not(:disabled)');
          const subscription = purchase ? purchase.value !== 'one_time' : Boolean(plan?.value);
          const unlocked = quantity >= 2 || subscription;
          if (this.unlocked === unlocked) return;
          this.unlocked = unlocked;
          this.querySelector('.cg-offer-gifts__hint').hidden = unlocked;
          this.querySelector('.cg-offer-gifts__unlocked').hidden = !unlocked;
        };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.form.addEventListener('change', this.schedule, { signal: this.controller.signal });
        this.form.addEventListener('input', this.schedule, { signal: this.controller.signal });
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value', 'disabled'] });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.unlocked = undefined;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["curvyglow-mobile-performance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!('IntersectionObserver' in window)) return;
    const tickers = new Map();
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = (ticker, visible) => {
      ticker.classList.toggle('cg-ticker-paused', !visible || document.hidden || motion.matches);
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        tickers.set(entry.target, entry.isIntersecting);
        update(entry.target, entry.isIntersecting);
      });
    });
    const refresh = () => tickers.forEach((visible, ticker) => update(ticker, visible));
    const register = (root = document) => {
      root.querySelectorAll('.horizontal-ticker').forEach(ticker => {
        if (tickers.has(ticker)) return;
        tickers.set(ticker, false);
        update(ticker, false);
        observer.observe(ticker);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => register(), { once: true });
    } else register();
    document.addEventListener('visibilitychange', refresh);
    motion.addEventListener('change', refresh);
    document.addEventListener('shopify:section:load', event => register(event.target));
    document.addEventListener('shopify:section:unload', event => {
      tickers.forEach((visible, ticker) => {
        if (!event.target.contains(ticker)) return;
        observer.unobserve(ticker);
        tickers.delete(ticker);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["curvyglow-side-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-side-cart')) {
    customElements.define('cg-side-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.body = this.querySelector('[data-cg-body]');
        this.status = this.querySelector('[data-cg-status]');
        this.fallback = this.querySelector('[data-cg-fallback]');
        this.section = 'curvyglow-drawer-items';
        this.busy = false;
        document.addEventListener('submit', event => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          const path = new URL(form.action, location.href).pathname.replace(/\/$/, '');
          if (path !== this.dataset.addUrl.replace(/\/$/, '') || !form.querySelector('[name="id"]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy || this.adding) return;
          const data = new FormData(form);
          data.delete('return_to');
          data.set('sections', this.section);
          data.set('sections_url', this.dataset.cartUrl);
          this.add(data, event.submitter || form.querySelector('button[type="submit"]'), form);
        }, { ...options, capture: true });
        document.addEventListener('click', event => {
          const stickyButton = event.target.closest('.sticky-atc__add_button');
          if (stickyButton && !stickyButton.disabled) {
            const packForm = document.getElementById(stickyButton.getAttribute('form'));
            if (packForm?.matches('.cg-packs__form')) {
              event.preventDefault();
              event.stopImmediatePropagation();
              const submit = packForm.querySelector('button[type="submit"]');
              if (submit && !submit.disabled) packForm.requestSubmit(submit);
              return;
            }
          }
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[href]');
          if (!link || this.contains(link) || link.target === '_blank' || link.hasAttribute('download')) return;
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== this.dataset.cartUrl.replace(/\/$/, '')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.show(link);
          if (!this.busy) this.refresh();
        }, { ...options, capture: true });
        this.addEventListener('click', event => {
          const close = event.target.closest('[data-cg-close]');
          if (close) { this.dialog.close(); return; }
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
            return;
          }
          const control = event.target.closest('[data-cg-delta], [data-cg-remove]');
          if (!control || this.busy) return;
          const item = control.closest('[data-line-key]');
          const input = item.querySelector('input');
          const quantity = control.hasAttribute('data-cg-remove') ? 0 : Math.max(0, Number(input.value) + Number(control.dataset.cgDelta));
          this.change(item, quantity);
        }, options);
        this.addEventListener('change', event => {
          if (!event.target.matches('.cg-panel-quantity input') || this.busy) return;
          if (!event.target.checkValidity()) { event.target.reportValidity(); return; }
          this.change(event.target.closest('[data-line-key]'), Number(event.target.value));
        }, options);
        this.addEventListener('submit', event => {
          if (!event.target.matches('.cg-panel-form')) return;
          if (document.activeElement?.matches('.cg-panel-quantity input')) {
            event.preventDefault();
            if (!this.busy && document.activeElement.checkValidity()) this.change(document.activeElement.closest('[data-line-key]'), Number(document.activeElement.value));
            return;
          }
          if (event.submitter?.name === 'checkout' && !this.busy) return;
          event.preventDefault();
          if (!this.busy && document.activeElement?.matches('.cg-panel-quantity input')) {
            this.change(document.activeElement.closest('[data-line-key]'), Number(document.activeElement.value));
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('cg-side-open');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        document.documentElement.classList.remove('cg-side-open');
      }
      show(opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        this.dialog.showModal();
        document.documentElement.classList.add('cg-side-open');
      }
      async add(data, button, form) {
        if (this.adding || this.busy) return;
        this.adding = true;
        const nodes = button ? [...button.childNodes] : [];
        const wasDisabled = button?.disabled;
        const feedback = form.querySelector('[data-cg-add-feedback]');
        if (feedback) feedback.textContent = this.dataset.addLoading;
        if (button) {
          button.disabled = true;
          button.textContent = this.dataset.addLoading;
        }
        try {
          const added = await this.mutate(this.dataset.addUrl + '.js', data);
          if (!this.isConnected) return;
          if (added) {
            if (feedback) feedback.textContent = this.dataset.added;
            if (button) {
              button.textContent = this.dataset.added;
              button.classList.add('cg-add-confirmed');
            }
            if (button && !this.dialog.open) await new Promise(resolve => setTimeout(resolve, 350));
          } else if (feedback) feedback.textContent = this.status.textContent;
          if (this.isConnected) this.show(button);
        } finally {
          if (button) {
            button.replaceChildren(...nodes);
            button.disabled = wasDisabled;
            button.classList.remove('cg-add-confirmed');
          }
          this.adding = false;
        }
      }
      setBusy(value) {
        this.busy = value;
        this.body.setAttribute('aria-busy', String(value));
        this.body.querySelectorAll('button:not([data-cg-close]), input').forEach(el => { el.disabled = value; });
        this.status.textContent = value ? this.dataset.loading : '';
        if (value) this.fallback.hidden = true;
      }
      fail(message) {
        this.status.textContent = typeof message === 'string' ? message : this.dataset.error;
        this.fallback.hidden = false;
      }
      render(html) {
        if (!html) throw new Error(this.dataset.error);
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-cg-drawer-items]');
        if (!content) throw new Error(this.dataset.error);
        const previousTotal = this.body.querySelector('.cg-panel-total strong')?.textContent;
        const nextTotal = content.querySelector('.cg-panel-total strong');
        if (this.dialog.open && previousTotal && nextTotal && previousTotal !== nextTotal.textContent) {
          nextTotal.classList.add('cg-total-updated');
        }
        this.body.replaceChildren(content);
        const count = Number(content.dataset.count) || 0;
        this.querySelector('[data-cg-count]').textContent = '(' + count + ')';
        const cartLink = document.getElementById('cart-icon-bubble');
        if (cartLink) {
          cartLink.setAttribute('aria-label', this.dataset.cartLabel + ' (' + count + ')');
          cartLink.querySelector('.cart-count-bubble')?.remove();
          if (count > 0) {
            const badge = document.createElement('div');
            badge.className = 'cart-count-bubble';
            badge.setAttribute('aria-hidden', 'true');
            const label = document.createElement('span');
            label.textContent = String(count);
            badge.append(label);
            cartLink.append(badge);
          }
        }
      }
      async fetchSection() {
        const url = new URL(this.dataset.cartUrl, location.origin);
        url.searchParams.set('section_id', this.section);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error(this.dataset.error);
        this.render(await response.text());
      }
      async refresh() {
        this.setBusy(true);
        try { await this.fetchSection(); this.setBusy(false); }
        catch (error) { this.setBusy(false); this.fail(this.dataset.error); }
      }
      async mutate(url, data, lineIndex) {
        this.setBusy(true);
        const request = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } };
        if (data instanceof FormData) request.body = data;
        else { request.headers['Content-Type'] = 'application/json'; request.body = JSON.stringify(data); }
        try {
          const response = await fetch(url, request);
          const result = await response.json();
          if (!response.ok || result.status >= 400) { const error = new Error(this.dataset.error); error.customerMessage = typeof result.description === 'string' ? result.description : this.dataset.error; throw error; }
          if (result.sections?.[this.section]) this.render(result.sections[this.section]);
          else await this.fetchSection();
          this.setBusy(false);
          if (lineIndex) {
            const input = this.body.querySelector('[data-line-index="' + lineIndex + '"] input');
            (input || this.querySelector('[data-cg-close]')).focus({ preventScroll: true });
          }
          return true;
        } catch (error) {
          this.setBusy(false);
          this.fail(error.customerMessage || this.dataset.error);
          return false;
        }
      }
      change(item, quantity) {
        if (!item || !Number.isInteger(quantity) || quantity < 0 || this.busy) return;
        this.mutate(this.dataset.changeUrl + '.js', { id: item.dataset.lineKey, quantity, sections: [this.section], sections_url: this.dataset.cartUrl }, item.dataset.lineIndex);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["curvyglow-timed-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-timed-offer')) {
    customElements.define('cg-timed-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.onVisibility) return;
        this.starts = Date.parse(this.dataset.start);
        this.ends = Date.parse(this.dataset.end);
        this.clock = this.querySelector('[data-cg-countdown]');
        this.onVisibility = () => this.update();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.onVisibility = null;
      }
      update() {
        clearTimeout(this.timer);
        const now = Date.now();
        const valid = Number.isFinite(this.starts) && Number.isFinite(this.ends) && this.ends > this.starts && this.clock;
        this.hidden = !valid || now < this.starts || now >= this.ends;
        if (!valid || now >= this.ends || document.hidden) return;
        if (now < this.starts) {
          this.timer = setTimeout(() => this.update(), Math.min(this.starts - now, 60000));
          return;
        }
        const remaining = Math.ceil((this.ends - now) / 1000);
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        this.clock.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
        this.timer = setTimeout(() => this.update(), Math.min(1000, this.ends - now));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
